import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { LoginRequest } from '../../../models/login/login-request';
import { Observable } from 'rxjs/internal/Observable';
import { LoginResponse } from '../../../models/login/login-response';
import { UrlConstants } from '../../../constants/url.constants';
import { SsoLoginRequest } from '../../../models/login/ssoLoginRequest';
import { SamlAccessInfo } from '../../../models/login/saml-access-info';

@Injectable({
  providedIn: "root",
})
export class LoginService {

  readonly http = inject(HttpClient);

  login(loginDtls: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(UrlConstants.LOGIN_URL, loginDtls);
  }
  logout():Observable<LoginResponse> {
    return this.http.get<LoginResponse>(UrlConstants.LOGOUT_URL);
  }

  ssoLogin(ssoLoginRequest: SsoLoginRequest) : Observable<LoginResponse>{
    return this.http.post<LoginResponse>(UrlConstants.SSO_LOGIN_URL, ssoLoginRequest);
  }

  getSsoAccessInfo(tenantSlug: string): Observable<SamlAccessInfo> {
    return this.http.get<SamlAccessInfo>(
      `${UrlConstants.SSO_ACCESS_INFO_URL}/${tenantSlug}/accessInfo`);
  }
}
